/* imods-symptom (symptoms-1, 2026-10-02): step view for the symptom pages. Presentation only: every situation and every
   model's causes are in the HTML (sections/imods-symptom.liquid). Sets [data-c] (situation anchor, "" = the head situation,
   "*" = every situation) and [data-m] (model key) on .sym; the model is shared with the rest of the site through imods.yours
   (sessionStorage, owner ruling D-11 A). A #anchor in the URL opens that situation.
   Design round 2 sitting 3 (review row E5, 2026-10-26): below 1040 px each family's causes are a fold (<details data-fold>, closed by
   snippets/imods-dr2-fold-close): the picked model's family (or the menu's ?ipod=<family>) opens, "Open all" opens a section's families,
   a #<situation>--<family> link opens that row in its situation, and the folds open again when the window grows to a computer's width.
   Sitting 4 (review row G7, 2026-10-26): a "Step-by-step guide" link to a guide that covers two models carries ?ipod=<picked model>, so
   the guide opens on that model (the guide page's own picker); no model picked = the plain guide URL, as in the HTML. */
(function () {
  var root = document.querySelector('[data-sym-root]');
  if (!root) return;
  var I = window.imods || {};
  var KEYS = ['3G', '4G', 'Photo', '5G', '6G', '7G', 'Mini1', 'Mini2'];
  var secs = Array.prototype.slice.call(root.querySelectorAll('[data-sym-sec]'));
  var ids = secs.map(function (s) { return s.id; });
  var links = Array.prototype.slice.call(root.querySelectorAll('[data-sym-choice]'));
  var radios = Array.prototype.slice.call(root.querySelectorAll('[data-sym-model]'));
  var showing = root.querySelector('[data-sym-showing]');
  var showingText = root.querySelector('[data-sym-showing-text]');
  var folds = Array.prototype.slice.call(root.querySelectorAll('details[data-fold]'));
  var bars = Array.prototype.slice.call(root.querySelectorAll('[data-fold-all]'));
  var guides = Array.prototype.slice.call(root.querySelectorAll('a.sym-guide[data-models]'));
  var phone = window.matchMedia('(max-width: 1039px)');
  var state = { c: '', m: '', f: '' };
  // a family picked in the iPod Repair menu (?ipod=<family>) wins over a remembered model from another family (Codex review 2026-10-02)
  var FAMS = { classic: ['6G', '7G'], video: ['5G'], g4photo: ['4G', 'Photo'], mini: ['Mini1', 'Mini2'], g3: ['3G'] };
  var famParam = null;
  try { famParam = new URLSearchParams(location.search).get('ipod'); } catch (err) {}

  function hashEl() {
    var h = decodeURIComponent((location.hash || '').replace(/^#/, ''));
    return h ? document.getElementById(h) : null;
  }
  function hashAnchor() {
    var h = decodeURIComponent((location.hash || '').replace(/^#/, ''));
    if (ids.indexOf(h) >= 0) return h;
    // a family row (#<situation>--<family>) opens its situation
    var t = hashEl(), s = t && t.matches && t.matches('details[data-fold]') ? t.closest('[data-sym-sec]') : null;
    return s && root.contains(s) ? s.id : '';
  }
  function openRow() {
    var t = hashEl();
    if (t && t.matches && t.matches('details[data-fold]') && root.contains(t)) { t.open = true; return t; }
    return null;
  }
  function labelOf(anchor) {
    var a = links.filter(function (l) { return l.getAttribute('data-sym-choice') === anchor; })[0];
    var l = a && a.querySelector('.sym-choice__l');
    return l ? l.textContent.trim() : '';
  }
  function modelLabel(k) {
    var r = radios.filter(function (x) { return x.value === k; })[0];
    return r ? r.getAttribute('data-label') : '';
  }
  function rerank() {
    root.querySelectorAll('.sym-fam').forEach(function (fam) {
      var n = 0;
      fam.querySelectorAll('.sym-cause:not(.sym-cause--more)').forEach(function (c) {
        if (c.offsetParent === null) return;
        n += 1;
        var r = c.querySelector('.sym-cause__rank');
        if (r) r.textContent = n === 1 ? 'Most likely' : n === 2 ? 'Next most likely' : 'Also possible';
      });
    });
    // S6: a "causes that only a situation lists" box hides when the picked model has none of them
    root.querySelectorAll('[data-sym-xtra]').forEach(function (x) {
      x.hidden = !Array.prototype.some.call(x.querySelectorAll('.sym-cause, .sym-xtra__i'), function (i) { return getComputedStyle(i).display !== 'none'; });
    });
  }
  function apply() {
    root.setAttribute('data-c', state.c);
    root.setAttribute('data-m', state.m);
    root.setAttribute('data-f', state.f);
    secs.forEach(function (s) { s.classList.toggle('is-on', s.id === state.c); });
    links.forEach(function (l) {
      if (l.getAttribute('data-sym-choice') === state.c) l.setAttribute('aria-current', 'true'); else l.removeAttribute('aria-current');
    });
    radios.forEach(function (r) { r.checked = r.value === state.m; });
    // the picked model's family (or the menu's family) opens in every situation; the others keep their state (hidden by the filter)
    if (state.m || state.f) folds.forEach(function (d) {
      var fam = d.closest('.sym-fam');
      // sitting 4 (B2): the situation's one "More causes" fold opens too (its rows are filtered to the pick)
      if (!fam) { if (d.hasAttribute('data-fold-xtra')) d.open = true; return; }
      if (state.m ? (' ' + fam.getAttribute('data-models') + ' ').indexOf(' ' + state.m + ' ') >= 0 : fam.getAttribute('data-fam') === state.f) d.open = true;
    });
    bars.forEach(function (b) { b.hidden = !phone.matches || !!(state.m || state.f); });
    var parts = [];
    if (state.c && state.c !== '*') parts.push(labelOf(state.c));
    if (state.m) parts.push(modelLabel(state.m));
    if (showing) {
      showing.hidden = !(parts.length || state.c === '*');
      if (showingText) showingText.textContent = state.c === '*' ? 'Showing every situation.' : 'Showing ' + parts.join(' on the ') + '.';
    }
    guides.forEach(function (a) {
      var gm = a.getAttribute('data-models').split(' '), base = a.getAttribute('href').split('?')[0];
      a.setAttribute('href', gm.length > 1 && state.m && gm.indexOf(state.m) >= 0 ? base + '?ipod=' + state.m : base);
    });
    rerank();
  }
  function scrollTo(el) {
    if (!el) return;
    el.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }
  // owner 2026-10-05 (S6): the URL follows the pick. A model or situation picked on the page rewrites ?ipod=<model key> (the family key
  // while a menu family is open with no model picked) and #<situation> with replaceState (no new Back-button entries); every other query
  // parameter is kept; "Show every situation and model" removes both. Only user actions rewrite the URL, never the page load.
  function syncUrl() {
    try {
      var q = new URLSearchParams(location.search);
      var v = state.m || state.f;
      if (v) q.set('ipod', v); else q.delete('ipod');
      var qs = q.toString();
      history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + (state.c && state.c !== '*' ? '#' + state.c : ''));
    } catch (err) {}
  }
  function target() {
    return state.c && state.c !== '*' ? document.getElementById(state.c) : secs.filter(function (s) { return s.getAttribute('data-kind') === 'head'; })[0];
  }

  root.classList.add('sym--js');
  // sitting 4 (B2, blind judges): on a computer the one "More causes" list sits after all five families; each family that has rows in
  // it ends with a link down to it (shown from 1040 px, hidden once a model is picked: the list then sits right under that family)
  root.querySelectorAll('details.sym-fold--xtra[id]').forEach(function (d) {
    var sec = d.closest('[data-sym-sec]'), rows = Array.prototype.slice.call(d.querySelectorAll('.sym-xtra__i'));
    if (!sec) return;
    var wrap = d.closest('.sym-xtra--all');
    sec.querySelectorAll('.sym-fam[data-fam]').forEach(function (fam) {
      if (fam.nextElementSibling === wrap) return;   // the last family: the list follows it directly
      var k = ' ' + fam.getAttribute('data-fam') + ' ';
      if (!rows.some(function (i) { return (' ' + i.getAttribute('data-fams') + ' ').indexOf(k) >= 0; })) return;
      var p = document.createElement('p'), a = document.createElement('a');
      p.className = 'sym-xjump'; a.href = '#' + d.id; a.textContent = 'More causes on this page, depending on what happens \u2193';
      a.addEventListener('click', function (e) { e.preventDefault(); d.open = true; scrollTo(d); });
      p.appendChild(a); (fam.querySelector('.fold-b') || fam).appendChild(p);
    });
  });
  bars.forEach(function (bar) {
    var btn = bar.querySelector('button'), sec = bar.closest('[data-sym-sec]') || root;
    if (!btn) return;
    btn.addEventListener('click', function () {
      var on = btn.getAttribute('aria-expanded') !== 'true';
      sec.querySelectorAll('details[data-fold]').forEach(function (d) { d.open = on; });
      btn.setAttribute('aria-expanded', String(on)); btn.textContent = on ? 'Close all' : 'Open all';
      rerank();
    });
  });
  folds.forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) rerank(); }); });
  if (phone.addEventListener) phone.addEventListener('change', function (e) {
    if (!e.matches) folds.forEach(function (d) { d.open = true; });
    bars.forEach(function (b) { b.hidden = !e.matches || !!(state.m || state.f); });
  });
  state.c = hashAnchor();
  var y = I.yours && I.yours.get ? I.yours.get() : null;
  if (y && KEYS.indexOf(y.key) >= 0) state.m = y.key;
  // owner 2026-10-02: the menu has one tab per model, so ?ipod= can also be a model key: open the page on exactly that model
  if (famParam && KEYS.indexOf(famParam) >= 0) state.m = famParam;
  else if (famParam && FAMS[famParam]) {
    if (FAMS[famParam].length === 1) state.m = FAMS[famParam][0];
    else if (FAMS[famParam].indexOf(state.m) < 0) { state.m = ''; state.f = famParam; }
  }
  apply();
  var row = openRow();
  if (row) scrollTo(row);
  else if (state.c) scrollTo(document.getElementById(state.c));

  links.forEach(function (l) {
    l.addEventListener('click', function (e) {
      e.preventDefault();
      state.c = l.getAttribute('data-sym-choice');
      apply();
      syncUrl();
      if (!state.m) {
        var step = document.getElementById('which-ipod');
        scrollTo(step);
        var first = step && step.querySelector('input');
        if (first) first.focus({ preventScroll: true });
      } else {
        scrollTo(target());
      }
    });
  });
  radios.forEach(function (r) {
    r.addEventListener('change', function () {
      if (!r.checked) return;
      state.m = r.value; state.f = '';
      if (I.yours && I.yours.set) I.yours.set({ key: r.value, label: r.getAttribute('data-label') });
      if (state.c === '*') state.c = '';
      apply();
      syncUrl();
      scrollTo(target());
    });
  });
  var all = root.querySelector('[data-sym-all]');
  if (all) all.addEventListener('click', function () { state.c = '*'; state.m = ''; state.f = ''; apply(); syncUrl(); });
  window.addEventListener('hashchange', function () { var h = hashAnchor(); if (h) { state.c = h; apply(); var r = openRow(); scrollTo(r || document.getElementById(h)); } });
})();
